export default __webpack_public_path__ + "static/media/marauders-map-v2-01-02.31c8d61a.jpg";